<template>
  <div class="transportDeliveryOrder">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <el-dialog title="选择入账日期" center :visible.sync="dialogVisible" width="20%">
      <el-date-picker
        v-model="postDate"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        placeholder="选择日期"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectDate">确 定</el-button>
      </span>
    </el-dialog>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...tokenInfo }"
    ></sirui-upload>
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '../../../api/financeCenter/payables';
  import DataBaseAPI from '@/api/dataBase';
  // import MASTER_API from '@/api/masterData/company.js';
  import AGENCY_API from '@/api/agencyContract/index';
  import tableMixins from '@/common/mixins/table.js';
  // import { filterEmpty } from '@/common/js/util';
  import siruiUpload from '@/components/SiruiUpload';
  import loading from '@/common/js/load.js'; //loading
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  import XEUtils from 'xe-utils';
  export default {
    name: 'payablesBillList',
    mixins: [tableMixins],
    components: {
      siruiUpload,
      BatchConfirmDialog,
    },
    data() {
      return {
        footerTotalCols: {
          amount: [
            'domesticTotalAmount',
            'domesticTotalWithoutTaxAmount',
            'domesticTaxAmount',
            'originalTotalAmount',
            'originalTotalWithoutTaxAmount',
            'originalTaxAmount',
          ],
          quantity: ['invoiceQuantity'],
        }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        action: API.IMPORT,
        query: {
          payable_invoice_company_name: null,
          payable_invoice_create_person_name: null,
          invoice_unit_name: null,
          payableInvoiceCompanyCode: null,
          departmentCode: null,
          invoiceUnitName: null,
          startDomesticTotalAmount: undefined,
          endDomesticTotalAmount: undefined,
          invoiceCode: null,
          payableInvoiceDepartmentCode: null,
          salesContractNo: null,
          startPayableInvoiceCreateDate: null,
          endPayableInvoiceCreateDate: null,
          purchaseContractNo: null,
          inboundBatchNo: null,
          salesLadingNo: null,
          startPostDate: null,
          endPostDate: null,
          payableInvoiceStatus: null,
          documentCode: null,
          batchSettleNo: null,
          postStatus: null,
          payableInvoiceCreatePersonNo: null,
          sortfield: '',
          invoiceType: null,
          accountingVoucher: null,
          fundPayableInvoiceExportDTOs: [],
          voucherCode: null,
          differInvoice: false,
          mark: null,
        },
        companyList: [], //公司列表
        departmentList: [], //部门列表
        dialogVisible: false,
        postDate: '',
        isFinance: false, // 业务人员判断
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'payableInvoiceCompanyCode',
            name: this.$t('payablesBillList.search.payableInvoiceCompanyName'),
            type: 'select',
            placeholder: this.$t('payablesBillList.search.companyCodePlaceholder'),
            options: this.companyList,
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
          },
          {
            prop: 'payableInvoiceDepartmentCode',
            name: this.$t('payablesBillList.search.payableInvoiceDepartmentCode'),
            placeholder: this.$t('payablesBillList.search.departPlaceholder'),
            type: 'select',
            options: this.departmentList,
          },
          /* {
          prop: "deliveryDepartment",
          name: this.$t("transportOrderList.search.deliveryDepartment"),
          type: "treeSelect",
          apiUrl: MASTER_API.LIST_COMPANY_API,
          apiData: {
            tenantCode: this.userInfo.tenantCode,
            adminFlag: this.userInfo.adminFlag
          },
          isName: true,
          clearable: false
        }, */
          {
            prop: 'invoiceUnitName', // 供应商
            name: this.$t('payablesBillList.search.invoiceUnitName'),
            type: 'searchTableSpec',
            searchType: 'supplier',
            extraData: {
              companyCode: this.query.payableInvoiceCompanyCode,
              departmentCode: this.query.payableInvoiceDepartmentCode,
            },
            isMultiple: true,
          },
          {
            prop: 'invoiceCode',
            name: this.$t('payablesBillList.search.invoiceCode'),
            type: 'input',
            placeholder: this.$t('payablesBillList.search.billNoPlaceholder'),
          },
          {
            prop: 'invoiceType',
            name: this.$t('payablesBillList.search.invoiceType'),
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'invoice_type' },
            type: 'ajaxSelect',
            placeholder: this.$t('payablesBillList.search.invoiceTypePlaceholder'),
          },
          {
            prop: 'startPayableInvoiceCreateDate',
            name: this.$t('payablesBillList.search.startPayableInvoiceCreateDate'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'endPayableInvoiceCreateDate',
            name: this.$t('payablesBillList.search.endPayableInvoiceCreateDate'),
            type: 'endDaterangePicker',
          },
          {
            prop: 'purchaseContractNo',
            name: this.$t('payablesBillList.search.purchaseContractNo'),
            type: 'input',
            searchType: 'contract',
            isMultiple: true,
            extraData: { contractCategory: 'purchase', contractStatus: 'ZT03' },
            placeholder: this.$t('payablesBillList.search.procurementContractPlaceholder'),
          },
          {
            prop: 'inboundBatchNo',
            name: this.$t('payablesBillList.search.inboundBatchNo'),
            type: 'input',
            searchType: 'warehouseBatch',
            isMultiple: true,
            placeholder: this.$t('payablesBillList.search.warehousingNoPlaceholder'),
          },
          {
            prop: 'documentCode',
            name: this.$t('payablesBillList.search.documentCode'),
            type: 'input',
            placeholder: this.$t('payablesBillList.search.documentNoPlaceholder'),
          },
          {
            type: 'inputRange',
            prop: ['startDomesticTotalAmount', 'endDomesticTotalAmount'],
            max: 99999999999999.99,
            min: -99999999999999.99,
            name: this.$t('payablesBillList.search.domesticTotalAmount'),
          },
          {
            type: 'ajaxSelect',
            prop: 'payableInvoiceStatus',
            name: this.$t('payablesBillList.search.payableInvoiceStatus'),
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'payable-invoice-status' },
            clearable: true,
          },
          /* {
            prop: 'batchSettleNo',
            name: this.$t('payablesBillList.search.batchSettleNo'),
            type: 'input',
            placeholder: this.$t('payablesBillList.search.settlementBatchPlaceholder'),
          },
          {
            type: 'ajaxSelect',
            prop: 'postStatus',
            name: this.$t('payablesBillList.search.postStatus'),
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'post_status' },
            clearable: true,
          },
          {
            type: 'searchTableSpec',
            prop: 'payableInvoiceCreatePerson',
            name: this.$t('payablesBillList.search.payableInvoiceCreatePerson'),
            isMultiple: true,
            searchType: 'personnel',
          },
          {
            prop: 'invoiceType',
            name: this.$t('payablesBillList.search.invoiceType'),
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'invoice_type' },
            type: 'ajaxSelect',
            placeholder: this.$t('payablesBillList.search.invoiceTypePlaceholder'),
          },
          {
            prop: 'voucherCode',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
          {
            prop: 'differInvoice',
            name: '是否差额发票',
            type: 'checkbox',
          },
          {
            prop: 'mark',
            name: '备注',
            type: 'input',
            span: 12,
            maxLength: 256,
            placeholder: this.$t('请输入备注'),
          }, */
          /* {
          prop: "accountingVoucher",
          name: this.$t("payablesBillList.search.accountingVoucher"),
          type: "select",
          placeholder: this.$t("payablesBillList.search.accountingVoucherPlaceholder"),
        }, */
        ];
      },

      //表格显示字段
      columnListDefault() {
        return [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          {
            field: 'payableInvoiceCompanyCode',
            title: 'payablesBillList.table.payableInvoiceCompanyCode',
            visible: true,
            width: 100,
          },
          //{ field: 'invoiceQuantity', title: '本次收票数量', visible: true, width: 100 },
          {
            field: 'payableInvoiceCompanyName',
            title: 'payablesBillList.table.payableInvoiceCompanyName',
            visible: true,
            width: 120,
          },
          {
            field: 'payableInvoiceDepartmentName',
            title: 'payablesBillList.table.payableInvoiceDepartmentName',
            visible: true,
            width: 120,
          },
          //部门
          {
            field: 'payableInvoiceStatus',
            title: 'payablesBillList.table.payableInvoiceStatus',
            visible: true,
            width: 120,
            dictType: 'payable-invoice-status',
          },
          {
            field: 'documentCode',
            title: 'payablesBillList.search.documentCode',
            visible: true,
            width: 180,
          },
          {
            field: 'invoiceType',
            title: 'payablesBillList.table.invoiceType',
            visible: true,
            width: 120,
            dictType: 'invoice_type',
          }, //invoice_type
          {
            field: 'invoiceCode',
            title: 'payablesBillList.table.invoiceCode',
            visible: true,
            width: 120,
          },
          {
            field: 'invoiceUnitName',
            title: 'payablesBillList.table.invoiceUnitName',
            visible: true,
            width: 120,
          },
          {
            field: 'currencyCode',
            title: 'payablesBillList.table.currencyCode',
            visible: true,
            width: 120,
            dictType: 'all_currency',
          },
          {
            field: 'domesticTotalAmount',
            title: 'payablesBillList.table.domesticTotalAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          },
          {
            field: 'domesticTotalWithoutTaxAmount',
            title: 'payablesBillList.table.domesticTotalWithoutTaxAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          },
          {
            field: 'domesticTaxAmount',
            title: 'payablesBillList.table.domesticTaxAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          },
          {
            field: 'originalTotalAmount',
            title: 'payablesBillList.table.originalTotalAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          },
          {
            field: 'originalTotalWithoutTaxAmount',
            title: 'payablesBillList.table.originalTotalWithoutTaxAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          },
          {
            field: 'originalTaxAmount',
            title: 'payablesBillList.table.originalTaxAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          },
          {
            field: 'payableInvoiceCreatePersonName',
            title: 'payablesBillList.table.payableInvoiceCreatePersonName',
            visible: true,
            width: 120,
          },
          {
            field: 'payableInvoiceCreateDate',
            title: 'payablesBillList.table.payableInvoiceCreateDate',
            visible: true,
            width: 120,
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      // this.initDepartment();
      // if (this.userInfo.companyCode != 'OAC19') {
      //   this.query.payableInvoiceCompanyCode = this.userInfo.companyCode;
      // }
      this.getCompany();
      this.getButtonList();
      this.$nextTick(() => {
        this.isFinance = !this.menuButtonList.find((item) => item.type === 'add');
        this.getData();
      });
    },
    methods: {
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        if (this.userInfo.companyCode != 'OAC19') {
          // this.query.payableInvoiceCompanyCode = this.userInfo.companyCode;
          // this.query.requestDepartmentCode = this.userInfo.departmentCode;
          // this.getdepartmentList(this.query.payableInvoiceCompanyCode);
        }

        this.getData();
      },
      //获取数据
      getData() {
        const query = this.setSearchParams();
        this.load = true;
        this.$axios.post(API.GET_DATA_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 查询参数整理
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        let query = { ...this.query, pageSize, pageNum };
        query.differInvoice = query.differInvoice ? 1 : 0;
        if (query.payableInvoiceCreatePerson && query.payableInvoiceCreatePerson.length > 0) {
          const { id, personName } = query.payableInvoiceCreatePerson[0];
          query.payableInvoiceCreatePersonNo = id; //单据中存的为人员ID
          query.payableInvoiceCreatePersonName = personName;
          delete query.payableInvoiceCreatePerson;
        } else {
          query.payableInvoiceCreatePersonNo = null;
          query.payableInvoiceCreatePersonName = null;
        }
        if (query.invoiceUnitName && query.invoiceUnitName.length > 0) {
          if (query.invoiceUnitName[0] && query.invoiceUnitName[0].partnerCode) {
            query.invoiceUnitName = query.invoiceUnitName[0].partnerZhName;
          } else {
            query.invoiceUnitName = '';
          }
        }
        return query;
      },
      // 字符串转成驼峰
      transformStr3(str) {
        var re = /-(\w)/g;
        return str.replace(re, function ($0, $1) {
          return $1.toUpperCase();
        });
      },
      //调用接口排序
      sortChangeEvent({ property }) {
        this.query.sortfield = this.transformStr3(property);
        this.getData();
      },
      // 选择公司
      searchCompanyName(val) {
        console.log(val);
        this.departmentList = [];
        this.query.payableInvoiceDepartmentCode = '';
        this.getdepartmentList(val.val);
      },
      // 根据公司查询部门
      // 获取部门
      getdepartmentList(companyCode) {
        this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type === 'add') {
          this.add();
        } else if (type === 'edit') {
          if (this.multipleSelection.length !== 1) {
            this.$message({ showClose: true, message: '请选择一条数据修改', type: 'error' });
          } else {
            const { payableInvoiceStatus } = this.multipleSelection[0];
            // if(['saved','withdraw','returned'].indexOf(payableInvoiceStatus)>-1&&!this.isFinance||['submitted','hold'].indexOf(payableInvoiceStatus)>-1&&this.isFinance){
            if (['saved', 'withdraw', 'returned'].indexOf(payableInvoiceStatus) > -1) {
              let path = {
                path: '/payables/editBill',
                name: 'editBill',
                meta: {
                  keepAlive: true,
                  title: '登记发票',
                },
                query: { id: this.multipleSelection[0].id },
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$message({ showClose: true, message: '该状态下不可修改', type: 'error' });
            }
          }
        } else if (type === 'export') {
          this.export();
        } else if (type === 'delete') {
          const item = this.multipleSelection.map((it) => it.payableInvoiceStatus);
          let sign = true;
          XEUtils.arrayEach(item, (arr) => {
            // 数组迭代器，只能用于遍历(数组或伪数组)，性能高于 each
            if (['saved', 'withdraw', 'returned'].indexOf(arr) == -1) {
              sign = false;
            }
          });
          if (!sign) {
            this.$message({ showClose: true, message: '所选发票存在不可删除数据', type: 'error' });
            return;
          }
          this.handleDelete();
        } else if (type === 'import') {
          this.handleImport();
        } else if (type == 'submit') {
          this.submit();
        } else if (type == 'syncVoucher') {
          this.batchSyncVoucher(API.BATCH_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'signSyncVoucher') {
          this.batchSyncVoucher(API.BATCH_SIGN_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'doBatchConfirm') {
          this.doBatchConfirm('AE_AP_INVOICES', {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type == 'batchPrint' || type == 'printBusniessInbound') {
          this.print(type);
        } else if (type == 'exportInvoice') {
          this.exportInvoice();
        }
      },
      //批量提交
      submit(params = this.multipleSelection.map((it) => it.id), cancelValidate = false) {
        loading.startLoading();
        this.$axios
          .post(API.BATCH_SUBMIT + (cancelValidate ? '?cancelValidate=true' : ''), params)
          .then((res) => {
            loading.endLoading();
            if (0 == res.data.code) {
              this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              this.getData();
            } else {
              this.$reportErrors({
                msg: res.data.msg,
                code: res.data.code,
                callback: () => {
                  //确认提交，cancelValidate传值true取消校验
                  this.submit(params, true);
                },
              });
            }
          })
          .catch(() => loading.endLoading());
      },
      //批量上传
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      // 删除
      handleDelete() {
        // const { id, version } = this.multipleSelection[0];
        // const fundPayableInvoiceStatusDTO = { id, lastModifiedBy: this.userInfo.userCode, version };
        this.$confirmAction()
          .then(() => {
            this.$axios
              .post(API.DELETE_INVOICE, { idList: this.multipleSelection.map((it) => it.id) })
              .then((res) => {
                if (0 == res.data.code) {
                  this.getData();
                  this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({ type: 'info', message: this.$t('confirm.deleteCancelled') });
          });
      },
      //新增
      add() {
        let path = {
          path: '/payables/addBill',
          name: 'addBill',
          meta: {
            keepAlive: true,
            title: '登记发票',
          },
          query: { isEdit: 'Y' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //获取公司信息
      async getCompany() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          // personCompanyCode: this.userInfo.companyCode,
        };
        const res = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        this.companyList = res.data.data?.personCompanyInfo.map((item) => {
          return {
            ...item,
            value: item.personCompanyCode,
            label: item.personCompanyName,
          };
        });
        if (this.query.payableInvoiceCompanyCode) {
          this.getdepartmentList(this.query.payableInvoiceCompanyCode);
        }
        // const selectStatus = await this.$axios.get(
        //   DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        // );
        // if (selectStatus.data.code == 0) {
        //   this.companyList = selectStatus.data.data;
        // }
      },
      // 导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          changeList.forEach((item) => {
            str += 'ids=' + item.id + '&';
          });
          window.location.href = `${this.baseUrl}${API.POST_LIST_EXPORT}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = this.setSearchParams();
          params = XEUtils.serialize(params);
          window.location.href = `${this.baseUrl}${API.POST_LIST_EXPORT}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },
      // 导出进项发票
      exportInvoice() {
        const ids = this.multipleSelection.map((item) => {
          return item.id;
        });
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        const params = {
          pageNum,
          pageSize,
          ids,
        };
        this.$axios.post(API.EXPORT_INPUT_INVOICE, params).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data.word;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },

      // 跳转详情页
      dblclickEvent(e) {
        let path = {
          path: '/payables/detailBill',
          name: 'detailBill',
          meta: {
            keepAlive: false,
            title: '发票详情',
          },
          query: { id: e.row.id, isEdit: 'N' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 批量生成凭证
      selectDate() {
        const fundPayableInvoiceCredentialDTO = this.multipleSelection.map((i) => {
          return {
            id: i.id,
            version: i.version,
            postDate: this.postDate,
          };
        });
        this.$axios.post(API.GENERATE_CREDENTIALS, fundPayableInvoiceCredentialDTO).then((res) => {
          if (0 == res.data.code) {
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },

      // 打印
      print(type) {
        const params = {};
        const selectedList = this.multipleSelection.concat(
          this.$refs.siruiTable.getCheckboxReserveRecords()
        );
        if (type == 'printBusniessInbound') {
          let hnList = selectedList.filter(
            (item) => item.payableInvoiceCompanyCode == this.$globalVar.subserver.companyCode
          );
          if (hnList.length > 0 && selectedList.length !== hnList.length) {
            this.$message({
              showClose: true,
              message: '海宁与其他公司的模板不同，不可以一起批量打印',
              type: 'error',
              duration: 8000,
            });
            return;
          }
          params.printFlag = hnList[0]
            ? 'PRINT_BUSINESSINBOUND_HN_BY_INVOICE'
            : 'PRINT_BUSINESSINBOUND_BY_INVOICE';
        } else {
          params.printFlag = 'PAYABLE_INVOICE';
        }
        params.getFileUrl = DataBaseAPI.GET_FILE;
        params.idList = [];
        selectedList.map((item) => {
          params.idList.push(item.id);
        });
        if (!params.idList.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.printEntityCode(params);
      },
    },
  };
</script>
